<ng-template #modalConfirmExport let-c="close" let-d="dismiss">
  <wsb-modal
    cancelButtonEnable="true"
    cancelButtonText="{{ 'common_cancel' | translate }}"
    primaryButtonText="{{ 'common_ok' | translate }}"
    (primary)="closeExportModal()"
    (dismiss)="d()"
  >
    <div body>
      <div translate>mail_detail_export_text</div>
    </div>
  </wsb-modal>
</ng-template>
<div class="page page--landing-campaings">
  <div class="page__container">
    <h1 class="page__title  h2">{{ 'stats_mail_issue_title' | translate }}</h1>
    <div class="my-5">
      <div class="mt-5 mb-5 d-flex mt-5">
        <div class="text-center" style="width: 33.33%;">
          <div class="doughnut d-flex flex-column mt-4">
            <canvas
              baseChart
              [data]="doughnutDeliveredData"
              [labels]="doughnutDeliveredLabels"
              [options]="doughnutOptions"
              [legend]="doughnutLegend"
              [type]="doughnutType"
            >
            </canvas>
            <div class="percent">
              <div class="test">{{ delivered ? delivered : '0' }} %</div>
            </div>
            <div class="align-self-center mt-3">
              <div class="text-center square">{{ 'stats_mail_charts_delivered' | translate }}</div>
            </div>
          </div>
        </div>

        <div class="text-center" style="width: 33.33%;">
          <div class="doughnut d-flex flex-column mt-4">
            <canvas
              baseChart
              [data]="doughnutOpenedData"
              [labels]="doughnutOpenedLabels"
              [options]="doughnutOptions"
              [legend]="doughnutLegend"
              [type]="doughnutType"
            >
            </canvas>
            <div class="percent">
              <div class="test">{{ emailStats?.uniqueOpensPercent ? emailStats?.uniqueOpensPercent : '0 %' }}</div>
            </div>
            <div class="align-self-center mt-3">
              <div class="text-center square">{{ 'stats_mail_charts_opened' | translate }}</div>
            </div>
          </div>
        </div>

        <div class="text-center" style="width: 33.33%;">
          <div class="doughnut d-flex flex-column mt-4">
            <canvas
              baseChart
              [data]="doughnutUnsubData"
              [labels]="doughnutUnsubLabels"
              [options]="doughnutOptions"
              [legend]="doughnutLegend"
              [type]="doughnutType"
            >
            </canvas>
            <div class="percent">
              <div class="test">{{ emailStats?.unsubscribePercent ? emailStats?.unsubscribePercent : '0 %' }}</div>
            </div>
            <div class="align-self-center mt-3">
              <div class="text-center square">{{ 'stats_mail_charts_unsubscriptions' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h3 translate>mail_recipients</h3>
    <div class="">
      <table *ngIf="emailStats" class="table">
        <tbody>
          <tr>
            <td class="left-column border-t-none font-weight-bold" translate>common_total</td>
            <td class="center-column views border-t-none font-weight-bold">{{ emailStats.numSent }}</td>
            <td class="right-column border-t-none"></td>
          </tr>
          <tr>
            <td class="left-column font-weight-bold" translate>mail_detail_bounces</td>
            <td class="center-column font-weight-bold">{{ emailStats.numBounces }}</td>
            <td class="right-column font-weight-bold">{{ emailStats.bouncesPercent }}</td>
          </tr>
          <tr>
            <td class="left-column" translate>common_unique_opens</td>
            <td class="center-column font-weight-bold">{{ emailStats.numUniqueOpens }}</td>
            <td class="right-column">{{ emailStats.uniqueOpensPercent }}</td>
          </tr>
          <tr>
            <td class="left-column" translate>mail_detail_unsubscribed</td>
            <td class="center-column font-weight-bold">{{ emailStats.numUnsubscribe }}</td>
            <td class="right-column">{{ emailStats.unsubscribePercent }}</td>
          </tr>
          <tr>
            <td class="left-column" translate>common_link_clicks</td>
            <td class="center-column views">{{ emailStats.numCliks }}</td>
            <td class="right-column"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="page__actions actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button (click)="openExportConfirmationModal()" class="btn btn-primary btn-sm" translate>
            {{ 'export_stat' | translate | uppercase }}
          </button>

          <button (click)="goBack()" class="btn  btn-secondary ms-3 btn-sm" translate>common_back</button>
        </div>
      </div>
    </div>
  </div>
</div>
